<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">学生管理</Breadcrumb-item>
        <Breadcrumb-item>学情反馈</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <Tabs type="card" v-model="svcTab">
      <TabPane label="新生服务" name="new"></TabPane>
      <TabPane label="老生服务" name="old"></TabPane>
      <TabPane v-if="!isStudyAdviser" label="进度展示" name="progress"></TabPane>
    </Tabs>
    <div class="search" v-show="svcTab !== 'progress'" @keyup.enter="search">
      <Form :label-width="80" :show-message="false" label-position="right">
        <Row :gutter="32">
          <Col :span="6">
            <Form-item label="学生ID">
              <Input name="uid" v-model="queryParam.uid" placeholder="精确学生ID"></Input>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="学导">
              <admin-user-select
                :status="1"
                adminGroupCode="userStudyAdviser"
                v-model="queryParam.adminUserId"
                :disabled="isStudyAdviser"
              ></admin-user-select>
            </Form-item>
          </Col>
          <Col :span="6" v-if="svcTab === 'old'">
            <Form-item label="服务状态">
              <Select v-model="queryParam.served" placeholder="全部" clearable>
                <Option :value="1">已服务</Option>
                <Option :value="0">待服务</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :span="6" v-if="svcTab === 'old'">
            <Form-item label="服务日期">
              <DatePicker
                type="daterange"
                format="yyyy-MM-dd"
                clearable
                placeholder="选择日期"
                style="width: 100%"
                v-model="serviceDateRange"
                @on-change="changeServiceDate"
              ></DatePicker>
            </Form-item>
          </Col>
        </Row>
        <Row :gutter="32" v-if="svcTab === 'old'">
          <Col :span="12">
            <Form-item label="课件">
              <Row :gutter="8">
                <Col :span="12">
                  <Select
                    v-model.number="queryParam.levelId"
                    filterable
                    clearable
                    transfer
                    placeholder="Level"
                    style="width: 100%"
                    @on-change="changeMaterialLevel"
                  >
                    <Option v-for="item in bookMaterialLevelList" :value="item.id" :key="'lv-' + item.id">
                      {{ item.title }}
                    </Option>
                  </Select>
                </Col>
                <Col :span="12">
                  <Select
                    v-model.number="queryParam.lessonId"
                    filterable
                    clearable
                    transfer
                    placeholder="Lesson"
                    style="width: 100%"
                  >
                    <Option v-for="item in bookMaterialLessonsList" :value="item.id" :key="'ls-' + item.id">
                      {{ item.id }}-{{ item.title }}
                    </Option>
                  </Select>
                </Col>
              </Row>
            </Form-item>
          </Col>
          <Col :span="12">
            <Form-item label="剩余课时">
              <Row :gutter="8">
                <Col :span="11">
                  <Input v-model="queryParam.leftHourMin" placeholder="最低"></Input>
                </Col>
                <Col :span="2" class="old-hour-split">-</Col>
                <Col :span="11">
                  <Input v-model="queryParam.leftHourMax" placeholder="最高"></Input>
                </Col>
              </Row>
            </Form-item>
          </Col>
        </Row>
        <Row :gutter="32">
          <Col :span="6">
            <Button type="primary" :loading="searchLoading" icon="search" @click="search">搜索</Button>
            <Button type="primary" :loading="exportLoading" :disable="exportLoading" style="margin-left: 8px" @click="exportData">导出</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <div class="new-svc-table" v-show="svcTab === 'new'">
      <List
        ref="dataList"
        :tableColumns="title"
        :reload="reload"
        :reloadWithPage="reloadWithPage"
        listUrl="/user/new-student-service/list"
        :params="queryParam"
        :onLoading="onLoading"
        :pageSize="20"
      />
    </div>
    <div class="old-svc-table" v-show="svcTab === 'old'">
      <div class="statistics" v-if="svcTab === 'old'">
        服务进度：<label>{{ servedCount }}/{{ studentTotal }}</label>
      </div>
      <List
        v-if="svcTab === 'old'"
        ref="oldDataList"
        :tableColumns="oldTitle"
        :reload="oldReload"
        :reloadWithPage="oldReloadWithPage"
        listUrl="/user/new-student-service/list"
        :params="queryParam"
        :onLoading="onLoading"
        :pageSize="20"
        @on-sort-change="handleOldSortChange"
      />
    </div>
    <div class="progress-svc-table" v-show="svcTab === 'progress'">
      <Table border :columns="progressTitle" :data="progressData" :loading="progressLoading"></Table>
    </div>
    <Modal
      v-model="editVisible"
      :title="editTitle"
      :mask-closable="false"
      transfer
      @on-ok="confirmEdit"
      @on-cancel="closeEdit"
    >
      <Input type="textarea" :rows="6" v-model="editValue" placeholder="请填写"></Input>
    </Modal>
  </div>
</template>

<script>
var SERVICE_WAYS = ['微信监课', '作业点评', '电话回访', 'classin上课']

function headerCell (h, text, tip) {
  return h('span', {
    attrs: {
      title: tip || text
    },
    style: {
      display: 'inline-block',
      lineHeight: '18px',
      whiteSpace: 'nowrap'
    }
  }, text)
}

export default {
  name: 'NewStudentService',
  data: function () {
    return {
      searchLoading: false,
      exportLoading: false,
      svcTab: 'new',
      oldTitle: [
        {
          title: '学生ID',
          key: 'uid',
          fixed: 'left',
          width: 100,
          align: 'center',
          render: (h, {row}) => {
            if (!row.uid) {
              return h('span', '')
            }
            return h('a', {
              on: {
                click: () => this.openInfoModal(row.uid)
              }
            }, String(row.uid))
          }
        },
        {title: '学生姓名', key: 'studentName', fixed: 'left', width: 140},
        {title: '外教总课时', key: 'foreignTotalHour', width: 110, align: 'center'},
        {title: '最近已上课件', key: 'lastFinishedLesson', width: 180},
        {title: '外教剩余课时', key: 'foreignLeftHour', width: 120, align: 'center', sortable: 'custom'},
        {
          title: '服务方式',
          key: 'serviceWay',
          width: 140,
          render: (h, {row}) => this.renderOldWay(h, row)
        },
        {
          title: '时长',
          key: 'duration',
          width: 110,
          render: (h, {row}) => this.renderOldInput(h, row, 'duration', '时长')
        },
        {
          title: '日期',
          key: 'serviceDate',
          width: 150,
          sortable: 'custom',
          render: (h, {row}) => this.renderOldDate(h, row)
        },
        {
          title: '备注',
          key: 'remark',
          minWidth: 180,
          render: (h, {row}) => this.renderOldText(h, row, 'remark', '备注')
        }
      ],
      reload: 0,
      reloadWithPage: 0,
      oldReload: 0,
      oldReloadWithPage: 0,
      servedCount: 0,
      studentTotal: 0,
      progressLoading: false,
      progressData: [],
      progressTitle: [
        {title: '班主任', key: 'adviserName', minWidth: 160},
        {
          title: '新生服务进度',
          key: 'newProgress',
          width: 160,
          align: 'center',
          render: (h, {row}) => this.renderProgress(h, row, 'new')
        },
        {
          title: '老生服务进度',
          key: 'oldProgress',
          width: 160,
          align: 'center',
          render: (h, {row}) => this.renderProgress(h, row, 'old')
        }
      ],
      serviceDateRange: [],
      bookMaterialLevelList: [],
      bookMaterialLessonsList: [],
      queryParam: {
        uid: '',
        adminUserId: null,
        served: '',
        serviceDateStart: '',
        serviceDateEnd: '',
        levelId: '',
        lessonId: '',
        leftHourMin: '',
        leftHourMax: ''
      },
      editVisible: false,
      editTitle: '',
      editValue: '',
      editRow: null,
      editField: '',
      isStudyAdviser: Number(this.$store.get('adminRule')) === 2,
      title: [
        {
          title: '序号',
          key: 'seq',
          fixed: 'left',
          width: 56,
          align: 'center'
        },
        {
          title: '学生信息',
          key: 'student',
          fixed: 'left',
          width: 150,
          render: (h, {row}) => this.renderStudent(h, row)
        },
        {
          title: '销售',
          key: 'adviserName',
          width: 90
        },
        {
          title: '开课日期',
          key: 'openCourseTime',
          width: 150,
          render: (h, {row}) => this.renderTime(h, row, 'openCourseTime', 'date')
        },
        {
          title: '首通时间',
          key: 'firstWeekTime',
          width: 200,
          renderHeader: (h) => headerCell(h, '首通时间', '第一周首通：沟通时间、沟通方式'),
          render: (h, {row}) => this.renderTimeAndWay(h, row, 'firstWeekTime', 'firstWeekWay')
        },
        {
          title: '首通内容',
          key: 'firstWeekContent',
          width: 220,
          renderHeader: (h) => headerCell(h, '首通内容', '1 了解学生信息:是否学过英语/报课原因/英语期望\n2 做高课耗&核对上课时间\n3 课程信息确认\n4 预复习告知 & 首月适应期打预防针\n5 请假规则 & 上课前智能语音电话提醒'),
          render: (h, {row}) => this.renderServiceContent(h, row, 'firstWeekContent', 'firstWeekServiceWay', '第一周首通内容')
        },
        {
          title: '1课后时间',
          key: 'firstVisitTime',
          width: 200,
          renderHeader: (h) => headerCell(h, '1课后时间', '第1次课后回访（72小时内）：沟通时间、沟通方式'),
          render: (h, {row}) => this.renderTimeAndWay(h, row, 'firstVisitTime', 'firstVisitWay')
        },
        {
          title: '1课后内容',
          key: 'firstVisitContent',
          width: 200,
          renderHeader: (h) => headerCell(h, '1课后内容', '1.确认是否适应课堂\n2.确认是否喜欢老师\n3.告知转介绍\n4.APP使用情况'),
          render: (h, {row}) => this.renderServiceContent(h, row, 'firstVisitContent', 'firstVisitServiceWay', '第1次课后回访内容')
        },
        {
          title: '5课后时间',
          key: 'fifthVisitTime',
          width: 200,
          renderHeader: (h) => headerCell(h, '5课后时间', '第5课课后回访（72小时内）：沟通时间、沟通方式'),
          render: (h, {row}) => this.renderTimeAndWay(h, row, 'fifthVisitTime', 'fifthVisitWay')
        },
        {
          title: '5课后内容',
          key: 'fifthVisitContent',
          width: 180,
          renderHeader: (h) => headerCell(h, '5课后内容', '监课反馈/电话'),
          render: (h, {row}) => this.renderServiceContent(h, row, 'fifthVisitContent', 'fifthVisitServiceWay', '监课反馈/电话')
        },
        {
          title: '10课时间',
          key: 'tenthVisitTime',
          width: 200,
          renderHeader: (h) => headerCell(h, '10课时间', '第10课电话（72小时内）：沟通时间、沟通方式'),
          render: (h, {row}) => this.renderTimeAndWay(h, row, 'tenthVisitTime', 'tenthVisitWay')
        },
        {
          title: '10课内容',
          key: 'tenthVisitContent',
          width: 220,
          renderHeader: (h) => headerCell(h, '10课内容', '1.学情分析（作业频率，出勤，纪律，学习环境）\n2.加课&转介绍\n3.赠送steve&meggie（L1-L3）\n4.提醒补升特权\n5.提醒后期服务频率'),
          render: (h, {row}) => this.renderServiceContent(h, row, 'tenthVisitContent', 'tenthVisitServiceWay', '第10课电话内容')
        }
      ]
    }
  },
  watch: {
    svcTab (val) {
      if (val === 'old') {
        this.$set(this.queryParam, 'oldStudent', 1)
        this.loadOldProgress()
      } else {
        this.$delete(this.queryParam, 'oldStudent')
        this.$delete(this.queryParam, 'served')
        this.$delete(this.queryParam, 'serviceDateStart')
        this.$delete(this.queryParam, 'serviceDateEnd')
        this.$delete(this.queryParam, 'sortProperty')
        this.$delete(this.queryParam, 'sortDirection')
        this.$delete(this.queryParam, 'levelId')
        this.$delete(this.queryParam, 'lessonId')
        this.$delete(this.queryParam, 'leftHourMin')
        this.$delete(this.queryParam, 'leftHourMax')
        this.serviceDateRange = []
        this.bookMaterialLessonsList = []
        if (val === 'progress') {
          this.loadProgress()
        } else {
          this.progressData = []
        }
      }
    }
  },
  created: function () {
    if (this.isStudyAdviser) {
      this.queryParam.adminUserId = parseInt(this.$store.get('id'))
    }
    this.loadBookMaterialLevel()
  },
  methods: {
    renderStudent (h, row) {
      if (!row.uid) {
        return h('span', row.student || '')
      }
      let name = ''
      let text = row.student ? String(row.student) : ''
      let prefix = String(row.uid) + '-'
      if (text.indexOf(prefix) === 0) {
        name = text.substring(prefix.length)
      } else if (text.indexOf('-') >= 0) {
        name = text.substring(text.indexOf('-') + 1)
      }
      return h('span', [
        h('a', {
          on: {
            click: () => this.openInfoModal(row.uid)
          }
        }, String(row.uid)),
        name ? h('span', '-' + name) : ''
      ])
    },
    openInfoModal (uid) {
      if (!uid) {
        return
      }
      let resolved = this.$router.resolve({
        name: 'userPayDetail',
        query: {uid: uid, tabName: 0, parm: this.queryParam, backPath: '/user/newStudentService'}
      })
      window.open(resolved.href, '_blank')
    },
    renderTime (h, row, key, type) {
      let pickerType = type || 'datetime'
      let format = pickerType === 'date' ? 'yyyy-MM-dd' : 'yyyy-MM-dd HH:mm:ss'
      let overdue = key === 'firstVisitTime' && !!row.firstVisitOverdue
      return h('DatePicker', {
        class: overdue ? 'new-svc-overdue' : '',
        props: {
          type: pickerType,
          value: row[key] || '',
          format: format,
          transfer: true,
          clearable: true,
          size: 'small',
          placeholder: pickerType === 'date' ? '选择日期' : '选择时间'
        },
        style: {
          width: pickerType === 'date' ? '128px' : '168px'
        },
        on: {
          'on-change': (val) => {
            this.$set(row, key, val || '')
            this.saveField(row, key, val || '')
          }
        }
      })
    },
    renderText (h, row, key, title) {
      let text = row[key] || ''
      return h('div', {
        class: 'new-svc-text',
        attrs: {
          title: text
        }
      }, [
        h('span', {
          class: text ? 'new-svc-text-body' : 'new-svc-text-empty'
        }, text || '未填写'),
        h('a', {
          class: 'new-svc-edit',
          on: {
            click: (e) => {
              if (e && e.stopPropagation) {
                e.stopPropagation()
              }
              this.openTextEdit(row, key, title)
            }
          }
        }, '编辑')
      ])
    },
    renderServiceContent (h, row, contentKey, wayKey, title) {
      let ways = SERVICE_WAYS
      let options = []
      for (let i = 0; i < ways.length; i++) {
        options.push(h('Option', {
          props: {
            value: ways[i]
          }
        }, ways[i]))
      }
      return h('div', {
        class: 'new-svc-content'
      }, [
        h('Select', {
          props: {
            value: row[wayKey] || '',
            clearable: true,
            transfer: true,
            size: 'small',
            placeholder: '服务方式'
          },
          style: {
            width: '100%',
            marginBottom: '4px'
          },
          on: {
            'on-change': (val) => {
              this.$set(row, wayKey, val || '')
              this.saveField(row, wayKey, val || '')
            }
          }
        }, options),
        this.renderText(h, row, contentKey, title)
      ])
    },
    renderTimeAndWay (h, row, timeKey, wayKey) {
      return h('div', {
        class: 'new-svc-time-way'
      }, [
        this.renderTime(h, row, timeKey, 'date'),
        this.renderText(h, row, wayKey, '沟通方式')
      ])
    },
    openTextEdit (row, field, title) {
      this.editRow = row
      this.editField = field
      this.editTitle = title
      this.editValue = row[field] || ''
      this.editVisible = true
    },
    closeEdit () {
      this.editVisible = false
      this.editRow = null
      this.editField = ''
      this.editValue = ''
    },
    confirmEdit () {
      if (!this.editRow || !this.editField) {
        this.closeEdit()
        return
      }
      let row = this.editRow
      let field = this.editField
      let value = this.editValue || ''
      this.$set(row, field, value)
      this.saveField(row, field, value)
      this.closeEdit()
    },
    renderOldWay (h, row) {
      let ways = SERVICE_WAYS
      let options = []
      for (let i = 0; i < ways.length; i++) {
        options.push(h('Option', {
          props: {
            value: ways[i]
          }
        }, ways[i]))
      }
      return h('Select', {
        props: {
          value: row.serviceWay || '',
          clearable: true,
          transfer: true,
          size: 'small',
          placeholder: '服务方式'
        },
        style: {
          width: '100%'
        },
        on: {
          'on-change': (val) => {
            this.setOldField(row, 'serviceWay', val || '')
          }
        }
      }, options)
    },
    renderOldInput (h, row, key, placeholder) {
      return h('Input', {
        props: {
          value: row[key] || '',
          size: 'small',
          placeholder: placeholder
        },
        on: {
          'on-blur': (e) => {
            let val = e && e.target ? e.target.value : ''
            this.setOldField(row, key, val || '')
          }
        }
      })
    },
    renderOldDate (h, row) {
      return h('DatePicker', {
        props: {
          type: 'date',
          value: row.serviceDate || '',
          format: 'yyyy-MM-dd',
          transfer: true,
          clearable: true,
          size: 'small',
          placeholder: '选择日期'
        },
        style: {
          width: '128px'
        },
        on: {
          'on-change': (val) => {
            this.setOldField(row, 'serviceDate', val || '')
          }
        }
      })
    },
    renderOldText (h, row, key, title) {
      return this.renderText(h, row, key, title)
    },
    renderProgress (h, row, type) {
      let servedKey = type === 'new' ? 'newServedCount' : 'oldServedCount'
      let totalKey = type === 'new' ? 'newStudentTotal' : 'oldStudentTotal'
      return h('span', (row[servedKey] || 0) + '/' + (row[totalKey] || 0))
    },
    setOldField (row, field, value) {
      this.$set(row, field, value)
      this.saveField(row, field, value)
    },
    saveField (row, field, value) {
      if (!row.uid) {
        this.$Message.error('学生ID不能为空')
        return
      }
      this.$http.post('/user/new-student-service/save', {
        uid: row.uid,
        field: field,
        value: value || ''
      }).then((res) => {
        if (res && res.status === 'ok') {
          this.$Message.success('已保存')
        }
        if (this.svcTab === 'old') {
          this.loadOldProgress()
        }
      })
    },
    loadOldProgress () {
      this.$http.post('/user/new-student-service/list', {
        oldStudent: 1,
        uid: this.queryParam.uid,
        adminUserId: this.queryParam.adminUserId,
        progress: 1,
        pageIndex: 1,
        pageSize: 1
      }).then((res) => {
        let data = res && res.data ? res.data : {}
        this.servedCount = data.servedCount || 0
        this.studentTotal = data.studentTotal || 0
      })
    },
    loadProgress () {
      this.progressLoading = true
      this.$http.post('/user/new-student-service/progress-by-adviser', {}).then((res) => {
        let list = res && res.status === 'ok' && Array.isArray(res.data) ? res.data : []
        this.progressData = list.map((item) => {
          return {
            adminUserId: item.adminUserId === undefined ? null : item.adminUserId,
            adviserName: item.adviserName || '',
            newServedCount: item.newServedCount || 0,
            newStudentTotal: item.newStudentTotal || 0,
            oldServedCount: item.oldServedCount || 0,
            oldStudentTotal: item.oldStudentTotal || 0
          }
        })
        this.progressLoading = false
      }).catch(() => {
        this.progressData = []
        this.progressLoading = false
      })
    },
    changeServiceDate (val) {
      if (val && val.length === 2 && val[0] && val[1]) {
        this.$set(this.queryParam, 'serviceDateStart', val[0])
        this.$set(this.queryParam, 'serviceDateEnd', val[1])
        return
      }
      this.$set(this.queryParam, 'serviceDateStart', '')
      this.$set(this.queryParam, 'serviceDateEnd', '')
    },
    loadBookMaterialLevel () {
      this.$http.get('/bookMaterialLevel/listByCondition?status=1').then((res) => {
        if (!res || !res.data) {
          return
        }
        this.bookMaterialLevelList = res.data
      })
    },
    changeMaterialLevel (val) {
      this.$set(this.queryParam, 'lessonId', '')
      this.bookMaterialLessonsList = []
      if (val) {
        this.$http.get('/bookMaterialLessons/listByCondition?status=1&levelId=' + val).then((res) => {
          if (!res || !res.data) {
            return
          }
          this.bookMaterialLessonsList = res.data
        })
      }
    },
    handleOldSortChange (column, key, order) {
      if (key !== 'foreignLeftHour' && key !== 'serviceDate') {
        return
      }
      this.$delete(this.queryParam, 'sortProperty')
      this.$delete(this.queryParam, 'sortDirection')
      if (order && order !== 'normal') {
        this.$set(this.queryParam, 'sortProperty', key)
        this.$set(this.queryParam, 'sortDirection', order)
      }
      this.oldReload = new Date().getTime()
    },
    search () {
      if (this.svcTab === 'old') {
        this.oldReload = new Date().getTime()
        this.loadOldProgress()
        return
      }
      this.reload = new Date().getTime()
    },
    exportData () {
      this.exportLoading = true
      this.$http({
        method: 'post',
        url: '/user/new-student-service/list-export',
        data: this.queryParam,
        responseType: 'arraybuffer'
      }).then((response) => {
        if (response.data) {
          let blob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
          let link = document.createElement('a')
          link.target = '_blank'
          link.href = window.URL.createObjectURL(blob)
          link.download = this.svcTab === 'old' ? '老生服务.xlsx' : '新生服务.xlsx'
          link.click()
          this.exportLoading = false
        } else {
          this.$Message.error(response.msg || '导出失败')
          this.exportLoading = false
        }
      }).catch(() => {
        this.$Message.error('导出失败')
        this.exportLoading = false
      })
    },
    onLoading (loading) {
      this.searchLoading = loading
    }
  }
}
</script>

<style lang="less" scoped>
.statistics {
  margin-bottom: 10px;

  label {
    font-weight: 600;
  }
}
.old-hour-split {
  text-align: center;
  line-height: 32px;
}
.new-svc-table {
  overflow-x: auto;
  /deep/ .ivu-table {
    font-size: 12px;
  }
  /deep/ .ivu-table-header table,
  /deep/ .ivu-table-body table {
    width: 2426px !important;
  }
  /deep/ .ivu-table th,
  /deep/ .ivu-table td {
    height: auto;
    padding: 0;
  }
  /deep/ .ivu-table-cell {
    padding: 6px 8px;
    overflow: hidden;
  }
  /deep/ .ivu-table-header th {
    white-space: nowrap;
  }
  /deep/ .new-svc-text {
    display: flex;
    align-items: flex-start;
  }
  /deep/ .new-svc-text-body,
  /deep/ .new-svc-text-empty {
    flex: 1;
    min-width: 0;
    margin-right: 6px;
    line-height: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
    word-break: break-all;
  }
  /deep/ .new-svc-text-empty {
    color: #c5c8ce;
  }
  /deep/ .new-svc-edit {
    flex-shrink: 0;
    line-height: 18px;
  }
  /deep/ .new-svc-content .ivu-select {
    display: block;
  }
  /deep/ .new-svc-time-way .ivu-date-picker {
    display: block;
    margin-bottom: 4px;
  }
  /deep/ .new-svc-overdue .ivu-input {
    border-color: #ed4014;
    color: #ed4014;
  }
}
.old-svc-table {
  /deep/ .ivu-table {
    font-size: 12px;
  }
  /deep/ .ivu-table th,
  /deep/ .ivu-table td {
    height: auto;
    padding: 0;
  }
  /deep/ .ivu-table-cell {
    padding: 6px 8px;
  }
  /deep/ .new-svc-text {
    display: flex;
    align-items: flex-start;
  }
  /deep/ .new-svc-text-body,
  /deep/ .new-svc-text-empty {
    flex: 1;
    min-width: 0;
    margin-right: 6px;
    line-height: 18px;
  }
  /deep/ .new-svc-text-empty {
    color: #c5c8ce;
  }
}
</style>



// WEBPACK FOOTER //
// NewStudentService.vue?07150f81